<app-page-layout>
  <h1>Contact</h1>
  <p>Please email ddarg at umd dot edu</p>
</app-page-layout>
